__turbopack_context__.v({
  "bg": "TwoHourDeliveryHero-module__r4A5dG__bg",
  "bottomScrim": "TwoHourDeliveryHero-module__r4A5dG__bottomScrim",
  "copy": "TwoHourDeliveryHero-module__r4A5dG__copy",
  "cta": "TwoHourDeliveryHero-module__r4A5dG__cta",
  "eyebrow": "TwoHourDeliveryHero-module__r4A5dG__eyebrow",
  "overlay": "TwoHourDeliveryHero-module__r4A5dG__overlay",
  "section": "TwoHourDeliveryHero-module__r4A5dG__section",
  "stacked": "TwoHourDeliveryHero-module__r4A5dG__stacked",
  "subtitle": "TwoHourDeliveryHero-module__r4A5dG__subtitle",
  "title": "TwoHourDeliveryHero-module__r4A5dG__title",
  "titleGroup": "TwoHourDeliveryHero-module__r4A5dG__titleGroup",
});
